export const BASE_URL = "https://pamwebapi.e-pam.pl/api";

export const environment= {
    jiraBaseUrl: "https://pamprojectpl.atlassian.net",
    jiraClientId: 'B0Ye0azFGBzwFqtgJfTI7Ujp2mqVTKDn',
    //jiraClientId: 'cqGDn6UBOeVEshIbOPHVP4yUyydBJ4nR',
    jiraRedirectUri: 'https://paminfo.e-pam.pl/auth/jira'
};

//export const BASE_URL = "https://pamwebapitest.e-pam.pl/api";

export const environment1= {
    jiraBaseUrl: "https://pamprojectpl.atlassian.net",
    //jiraClientId: 'B0Ye0azFGBzwFqtgJfTI7Ujp2mqVTKDn',
    jiraClientId: 'cqGDn6UBOeVEshIbOPHVP4yUyydBJ4nR',
    jiraRedirectUri: 'http://localhost:4300/auth/jira'
};
